import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toHandlers as _toHandlers, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-46445aea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-right" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_4 = { class: "name text-input col-span-1" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Nome blocco", -1))
const _hoisted_6 = {
  key: 0,
  class: "font-light text-red-500"
}
const _hoisted_7 = { class: "address text-input" }
const _hoisted_8 = { for: "address" }
const _hoisted_9 = {
  key: 0,
  class: "font-light text-red-500"
}
const _hoisted_10 = { class: "address text-input" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "address" }, "Latitudine", -1))
const _hoisted_12 = {
  key: 0,
  class: "font-light text-red-500"
}
const _hoisted_13 = { class: "address text-input" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "address" }, "Longitudine", -1))
const _hoisted_15 = {
  key: 0,
  class: "font-light text-red-500"
}
const _hoisted_16 = { class: "date text-input" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "start-date" }, "Data inizio", -1))
const _hoisted_18 = ["value"]
const _hoisted_19 = {
  key: 0,
  class: "font-light text-red-500"
}
const _hoisted_20 = {
  key: 1,
  class: "font-light text-red-500"
}
const _hoisted_21 = { class: "date text-input" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "end-date" }, "Data fine (opzionale)", -1))
const _hoisted_23 = ["value"]
const _hoisted_24 = {
  key: 0,
  class: "font-light text-red-500"
}
const _hoisted_25 = {
  key: 0,
  class: "re-generation-alert border-orange-400 border-2 col-span-2 rounded p-4 mt-2"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-lg font-bold text-orange-400" }, "Attenzione", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Modificando il blocco sarà necessario rigenerare il QR code ad esso relativo.", -1))
const _hoisted_28 = [
  _hoisted_26,
  _hoisted_27
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimaryButton = _resolveComponent("PrimaryButton")!
  const _component_GMapAutocomplete = _resolveComponent("GMapAutocomplete")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_ModalDialog = _resolveComponent("ModalDialog")!

  return (_openBlock(), _createBlock(_component_ModalDialog, { class: "add-new-working-site-modal-dialog" }, {
    h1: _withCtx(() => [
      _createElementVNode("span", null, _toDisplayString(_ctx.title), 1)
    ]),
    h2: _withCtx(() => [
      _createElementVNode("span", null, _toDisplayString(_ctx.subtitle), 1)
    ]),
    buttons: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_PrimaryButton, {
          class: "button bg-white text-gray-600 undo",
          onClick: _ctx.onClose
        }, {
          default: _withCtx(() => [
            _createTextVNode("Annulla")
          ]),
          _: 1
        }, 8, ["onClick"]),
        (_ctx.isEditing)
          ? (_openBlock(), _createBlock(_component_PrimaryButton, {
              key: 0,
              class: "button bg-primary-900 text-white",
              onClick: _ctx.update
            }, {
              default: _withCtx(() => [
                _createTextVNode("Aggiorna")
              ]),
              _: 1
            }, 8, ["onClick"]))
          : (_openBlock(), _createBlock(_component_PrimaryButton, {
              key: 1,
              class: "button bg-primary-900 text-white",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.create()))
            }, {
              default: _withCtx(() => [
                _createTextVNode("Crea")
              ]),
              _: 1
            }))
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _withDirectives(_createElementVNode("input", {
              class: _normalizeClass(["bg-white border-red-400", { border: _ctx.v$.step1.name.$error }]),
              id: "name",
              type: "text",
              placeholder: "Inserisci il nome del blocco",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.step1.name) = $event)),
              onBlur: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.v$.step1.name.$touch && _ctx.v$.step1.name.$touch(...args)))
            }, null, 34), [
              [_vModelText, _ctx.step1.name]
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.step1.name.$errors, (error) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "errors",
                key: error.$uid
              }, [
                (error.$validator == 'required')
                  ? (_openBlock(), _createElementBlock("label", _hoisted_6, "È necessario inserire il nome del blocco."))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("label", _hoisted_8, [
              _createTextVNode("Località"),
              _createVNode(_component_GMapAutocomplete, {
                class: _normalizeClass(["bg-white border-red-400", {'placeholder-as-text': _ctx.wsaPlaceholderIsAddress }]),
                id: "address",
                placeholder: _ctx.workingSiteAddressPlaceholder,
                onPlace_changed: _ctx.onGmapAutocompleteAddress
              }, null, 8, ["placeholder", "onPlace_changed", "class"])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.step1.address.$errors, (error) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "errors",
                key: error.$uid
              }, [
                (error.$validator == 'required')
                  ? (_openBlock(), _createElementBlock("label", _hoisted_9, "È necessario inserire la località del blocco."))
                  : _createCommentVNode("", true)
              ]))
            }), 128)),
            _withDirectives(_createElementVNode("input", {
              type: "hidden",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.step1.address) = $event))
            }, null, 512), [
              [_vModelText, _ctx.step1.address]
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.step1.lat) = $event))
            }, null, 512), [
              [_vModelText, _ctx.step1.lat]
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.step1.lat.$errors, (error) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "errors",
                key: error.$uid
              }, [
                (error.$validator == 'required')
                  ? (_openBlock(), _createElementBlock("label", _hoisted_12, "È necessario inserire una latitudine"))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.step1.lng) = $event))
            }, null, 512), [
              [_vModelText, _ctx.step1.lng]
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.step1.lng.$errors, (error) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "errors",
                key: error.$uid
              }, [
                (error.$validator == 'required')
                  ? (_openBlock(), _createElementBlock("label", _hoisted_15, "È necessario inserire una longitudine"))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createVNode(_component_DatePicker, {
              modelValue: _ctx.step1.startDate,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.step1.startDate) = $event)),
              mode: "date",
              "input-debounce": 500
            }, {
              default: _withCtx(({ inputValue, inputEvents }) => [
                _createElementVNode("input", _mergeProps({
                  class: "bg-white border-red-400",
                  id: "start-date",
                  type: "text",
                  placeholder: "gg/mm/aaaa",
                  value: inputValue
                }, _toHandlers(inputEvents, true), {
                  class: { border: _ctx.v$.step1.startDate.$error },
                  onBlur: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.v$.step1.startDate.$touch && _ctx.v$.step1.startDate.$touch(...args)))
                }), null, 16, _hoisted_18)
              ]),
              _: 1
            }, 8, ["modelValue"]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.step1.startDate.$errors, (error) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "errors",
                key: error.$uid
              }, [
                (error.$validator == 'required')
                  ? (_openBlock(), _createElementBlock("label", _hoisted_19, "È necessario inserire la data di inizio blocco"))
                  : _createCommentVNode("", true),
                (error.$validator == 'dateValidator')
                  ? (_openBlock(), _createElementBlock("label", _hoisted_20, "La data inserita non è valida"))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createVNode(_component_DatePicker, {
              modelValue: _ctx.step1.endDate,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.step1.endDate) = $event)),
              mode: "date",
              "input-debounce": 500
            }, {
              default: _withCtx(({ inputValue, inputEvents }) => [
                _createElementVNode("input", _mergeProps({
                  class: "bg-white border-red-400",
                  id: "end-date",
                  type: "text",
                  placeholder: "gg/mm/aaaa",
                  value: inputValue
                }, _toHandlers(inputEvents, true)), null, 16, _hoisted_23)
              ]),
              _: 1
            }, 8, ["modelValue"]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.step1.endDate.$errors, (error) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "errors",
                key: error.$uid
              }, [
                (error.$validator == 'dateValidator')
                  ? (_openBlock(), _createElementBlock("label", _hoisted_24, "La data inserita non è valida"))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]),
          (_ctx.isEditing)
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, _hoisted_28))
            : _createCommentVNode("", true)
        ])
      ]),
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_Loader, {
            key: 0,
            message: "Salvataggio..."
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}